
export const trackEvent = async (action, details = null) => {
    // Legacy tracking disabled. Backend /logs endpoint no longer exists.
    // console.log("Tracker action:", action, details);
};
